import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ISagaCb } from '@typings/requestPayloads'

export interface ICreateTourPayload extends ISagaCb {
    data: any
    sagaCB?: {
        onSuccess: any
        onError?: any
    }
}

export interface ICreateTourState {
    status: string
    data: any
    errors: any
}

const initialState: ICreateTourState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const createTour = createSlice({
    name: 'tour/create',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<ICreateTourPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const createTourActions = createTour.actions
export default createTour.reducer
